module.exports = __webpack_public_path__ + "img/rostand.8bb79f3b.jpg";